
/**
 * Module dependencies.
 */

import { prop, theme } from 'styled-tools';
import styled from 'styled-components';

/**
 * `Props` type.
 */

type Props = {
  className?: string;
  size?: number;
};

/**
 * `Wrapper` styled component.
 */

const Wrapper = styled.span`
  align-items: center;
  display: flex;
  justify-content: center;
`;

/**
 * `Circle` styled component.
 */

const Circle = styled.span<{ size: number }>`
  animation: ${theme('keyframes.pulse')} cubic-bezier(0.55, 0.055, 0.675, 0.19) 0.5s infinite alternate both;
  background-color: currentColor;
  border-radius: 50%;
  height: ${prop('size')}px;
  width: ${prop('size')}px;

  &:nth-child(2) {
    animation-delay: 0.15s;
  }

  &:nth-child(3) {
    animation-delay: 0.3s;
  }
`;

/**
 * Export `Circles` component.
 */

export function Circles(props: Props): JSX.Element {
  const { className, size = 24 } = props;

  return (
    <Wrapper className={className}>
      <Circle size={size} />
      <Circle size={size} />
      <Circle size={size} />
    </Wrapper>
  );
}
